import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Products } from '../components/Products';
import { About } from '../components/About';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen flex flex-col" data-id="element-165">
      <Header data-id="element-166" />
      <main className="flex-grow" data-id="element-167">
        <Hero data-id="element-168" />
        <About data-id="element-169" />
        <Products data-id="element-170" />
        <WhyChooseUs data-id="element-171" />
        <Contact data-id="element-172" />
      </main>
      <Footer data-id="element-173" />
    </div>;
}